import entities from './entities'

const NEVER_PERSIST = new Set([
    'email', 'pdf', 'file', 'image', 'stats', 'fxRate', 'test',
])

const getPersistableEntities = () => {
    const result = []
    for (const [name, config] of Object.entries(entities)) {
        if (config.cache === false) continue
        if (NEVER_PERSIST.has(name)) continue
        result.push(name)
    }
    return result
}

export default getPersistableEntities
